import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const PaymentHistoryRoutes = createFeatureRoutes(
  'payment-history',
  {
    list: () => import('../presentation/pages/PaymentHistoryPage/index'),
    details: () => import('../presentation/pages/PaymentHistoryDetails/index'),
    invoicedetails: () => import('../../home/presentation/pages/InvoiceDetails/index'),
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'details', pageKey: 'details' },
    { path: ':id', pageKey: 'details' },
    { path: 'invoice/:id', pageKey: 'invoicedetails' },
  ],
);

export default PaymentHistoryRoutes;
